module.exports = __webpack_public_path__ + "static/media/bg_xiaoxun.588f890a.png";